export default __webpack_public_path__ + "static/models-1-36986e65c69d3d93622b56093dd1996a.mp4";